<div class="login-container">
  <div class="content-login">
    <div
      class="w-100 h-100 gap-3 d-flex align-items-center justify-content-center"
    >
      <div
        class="d-flex flex-column gap-3 col-lg-6 col-xl-5 col-12 col-md-6 justify-content-center text-center"
      >
        <div class="d-felx justify-content-center">
          <img
            style="max-height: 50px"
            src="https://storage.googleapis.com/komerce/core/RO%20by%20Komerce.svg"
          />
        </div>
        <div>
          <div
            class="px-md-5 px-3 py-5 m-3 card shadow d-flex flex-column gap-3 justify-content-center text-center align-items-center"
          >
            <div
              *ngIf="title === 'Verifying'"
              class="cssload-speeding-wheel"
            ></div>
            <img
              *ngIf="title !== 'Verifying'"
              style="max-height: 60px"
              src="https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg"
            />
            <h5>
              <strong>{{ title }}</strong>
            </h5>
            <span
              *ngIf="
                title !== 'Verifying' &&
                title !== 'Verification Failed, Please Try Again'
              "
              >Please
              <a href="/login" class="text-yellow">login</a> using your registered email</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
